;(function () {
  'use strict'

  angular.module('contrast.label').directive('csLabelBeta', csLabelBeta)

  function csLabelBeta(csBetaCveShields, csBetaRulesService) {
    'ngInject'

    return {
      restrict: 'E',
      template:
        '<cs-label rounded text="\'beta\'" tooltip-placement="right" tooltip-class="tooltip-robust" uib-tooltip="{{\'variable_labelBeta_betaRuleDescription\' | translate:{ listOfBetaLanguages: betaLanguages } }}" tooltip-append-to-body="true"></cs-label>',
      scope: {
        type: '@',
        data: '=',
        language: '='
      },
      link: function ($scope, elem) {
        var match = false
        if (angular.isString($scope.data) && angular.isString($scope.type)) {
          var data = $scope.data.toLowerCase()
          var type = $scope.type
          if (type === 'cveShield') {
            match = angular.isDefined(
              csBetaCveShields.find(function (s) {
                return s.toLowerCase() === data
              })
            )
          } else if (type === 'rule') {
            var betaRule = csBetaRulesService.getBetaRule(data, $scope.language)
            match = angular.isDefined(betaRule)
            if (betaRule) {
              $scope.betaLanguages = betaRule.languages.join(', ')
            }
          }
        }
        if (!match) {
          elem.css({ display: 'none' })
        }
      }
    }
  }
})()
